<template>
  <div class="mid-bottom">
    <div class="mid-bottom-title">新增订单</div>
    <div class="mid-bottom-part-box">
      <div class="mid-bottom-part">
        <div class="mid-bottom-part-left">
          <!-- <div class="animation-box"> -->
          <!-- <span v-for="(item, index) in productList" :key="index"
              >{{ item.order_number + "   " }}{{ item.product_name }}</span
            > -->
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in productList" :key="index"><span>{{ item.order_number}}</span>{{ item.product_name }}</div>
            </div>
          </div>
        </div>
        <div class="mid-bottom-part-right">
          <div class="mid-bottom-circle-one">
            <div class="mid-bottom-circle-box">
              <div class="mid-bottom-circle circle-right-box">
                <div class="circle circle-right" :style="{ '-webkit-transform': `rotate(${
                      avg_user_deg > 180 ? 45 : -135 + avg_user_deg
                    }deg)`
                  }"
                ></div>
              </div>

              <div class="mid-bottom-circle circle-left-box">
                <div class="circle circle-left" :style="{
                    '-webkit-transform': `rotate(${
                      avg_user_deg > 180 ? -135 + avg_user_deg - 180 : -135
                    }deg)`
                  }"
                ></div>
              </div>
              <div class="mid-bottom-circle-num">
                {{ otherData.avg_user_order }}元
              </div>
            </div>
            <div class="mid-bottom-circle-title">平均客单</div>
          </div>
            <div class="mid-bottom-circle-one">
                <div class="mid-bottom-circle-box">
                <div class="mid-bottom-circle circle-right-box">
                    <!-- <div class="circle circle-right2" :style="{
                        '-webkit-transform': `rotate(${
                            seven_deg > 180 ? 45 : -135 + seven_deg
                        }deg)`
                    }"
                    ></div> -->
                </div>

                <div class="mid-bottom-circle circle-left-box">
                    <!-- <div class="circle circle-left2" :style="{
                        '-webkit-seven_deg': `rotate(${
                        seven_deg > 180 ? (seven_deg > 360 ? 45 : -135 + seven_deg - 180) : -135
                        }deg)`
                    }"
                    ></div> -->
                </div>
                <div class="mid-bottom-circle-num">{{seven}}台</div>
                </div>
                <div class="mid-bottom-circle-title">7日台均</div>
            </div>
            <div class="mid-bottom-circle-one">
                <div class="mid-bottom-circle-box">
                <div class="mid-bottom-circle circle-right-box"></div>
                <div class="mid-bottom-circle circle-left-box"></div>
                <div class="mid-bottom-circle-num">{{thirty}}台</div>
                </div>
                <div class="mid-bottom-circle-title">30日台均</div>
            </div>
        </div>
        <span class="mid-bottom-part-border"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
    data() {
        return {
            avg_user_deg: 0, //平均客单deg
            seven: 0,
            thirty: 0,
        };
    },
    computed: {
        productList: function() {
            return this.$store.getters.getState("productList");
        },
        otherData: function() {
            return this.$store.getters.getState("otherData");
        }
    },
    watch: {
        otherData: function(newVal, oldVal) {
            let device_avg = newVal.device_avg;
            this.seven = device_avg.seven;
            this.thirty = device_avg.thirty;
            // 平均客单
            let avg = Number(newVal.avg_user_order);
            let max = newVal.order_money_max;
            let rate = Math.floor((avg / max) * 100) / 100;
            this.avg_user_deg = 360 * rate || 0;
        }
    },
    mounted() {
        this.$nextTick(function() {
            this._initswiper();
        });
    },
    methods: {
        _initswiper() {
            var mySwiper = new Swiper(".swiper-container", {
                direction: "vertical", // 垂直切换选项
                slidesPerView: 1,
                height: 30,
                spaceBetween: 0,
                speed: 1000,
                autoplay: {
                delay: 1000,
                disableOnInteraction: false
                },
                loop: true, // 循环模式选项
                observeParents:true,   //修改swiper自己或子元素时，自动初始化swiper
                observer:true,         //修改swiper的父元素时，自动初始化swiper
            });
        // console.log("111111");
        }
    }
};
</script>

<style scoped>
@import "../../../node_modules/swiper/css/swiper.min.css";
.mid-bottom {
  width: 100%;
  height: 20%;
  border-radius: 10px;
  position: relative;
  margin-bottom: 0.2rem;
}
.mid-bottom-title {
  width: 50%;
  height: 0.36rem;
  line-height: 0.36rem;
  font-size: 0.22rem;
  color: #0efcff;
  padding: 0 20px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0.05rem;
  background: linear-gradient(
    to right,
    rgba(25, 54, 112, 1),
    rgba(25, 54, 112, 0)
  );
  overflow: hidden;
}
.mid-bottom-title::before {
  content: "";
  width: 0.14rem;
  height: 0.14rem;
  background: #0efcff;
  border: 5px solid #000218;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
}
.mid-bottom-title::after {
  content: "";
  width: 0.1rem;
  height: 0.1rem;
  background: #000218;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-50%) translateY(50%) rotateZ(45deg);
}
.mid-bottom-part-box {
  width: 100%;
  height: 100%;
  padding: 0.5rem 0.05rem 0.05rem;
  box-sizing: border-box;
  overflow: hidden;
}
.mid-bottom-part {
  width: 100%;
  height: 100%;
  border: 1px solid #b4c9ff;
  border-top: 1px solid #b4c9ff;
  position: relative;
  /* box-shadow: 0 0 1px #0eadff,0 0 1px #0eadff inset,1px 0px 1px #0eadff inset; */
  border-radius: 10px 20px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  box-sizing: border-box;
}
/* .mid-bottom-part-left {
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 2% 0;
  box-sizing: border-box;
} */
/* .mid-bottom-part-left span {
  display: inline-block;
  width: 33%;
  font-size: 0.14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */
.mid-bottom-part-left {
  width: 60%;
  height: 90%;
  padding: 2% 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}
/* .animation-box {
  position: absolute;
  top: 100%;
  left: 0;
  animation: moveUp 200s linear infinite;
  animation-fill-mode: forwards;
} */
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-wrapper {
  display: flex;
}
.swiper-slide {
  line-height: 0.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mid-bottom-part-left span {
  /* display: inline-block; */
  width: 100%;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  padding-left: 0.15rem;
  padding-right: 0.2rem;
}
.mid-bottom-part-left span::before {
  content: "";
  display: inline-block;
  width: 0.06rem;
  height: 0.06rem;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  background: #0efcff;
}
@keyframes moveUp {
  0% {
    transform: translateY(0%);
    opacity: 1;
  }
  98% {
    transform: translateY(calc(-100% - 20vh));
    opacity: 1;
  }
  99% {
    transform: translateY(calc(-100% - 20vh));
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 0;
  }
}
.mid-bottom-part-right {
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mid-bottom-part::before {
  content: "";
  width: 0.1rem;
  height: 0.1rem;
  background: #000218;
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%) translateY(-50%) rotateZ(45deg);
  border-right: 1.5px solid #b4c9ff;
}
.mid-bottom-part::after {
  content: "";
  width: 0.3rem;
  height: 0.3rem;
  background: #000218;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-50%) translateY(50%) rotateZ(45deg);
  border-top: 1.5px solid #b4c9ff;
  /* box-shadow: 0px -1px 1px #0eadff; */
}
.mid-bottom-part-border {
  width: 0.3rem;
  height: 0.3rem;
  background: #000218;
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(50%) translateY(-50%) rotateZ(45deg);
  border-bottom: 1.5px solid #b4c9ff;
  /* box-shadow: 0px 1px 1px #0eadff; */
}
.mid-bottom-circle-one {
  width: 33.33%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.mid-bottom-circle-title {
  width: 100%;
  text-align: center;
  font-size: 0.14rem;
}
.mid-bottom-circle-box {
  position: relative;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
}
.mid-bottom-circle-box::after {
  content: "";
  width: 0.7rem;
  height: 0.7rem;
  background: #192a52;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  border-radius: 50%;
  border: 0.06rem solid #23396d;
  z-index: -1;
}
.mid-bottom-circle-num {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
}
.mid-bottom-circle-box .mid-bottom-circle {
  width: 0.35rem;
  height: 0.7rem;
  position: absolute;
  top: 0;
  overflow: hidden;
}

.mid-bottom-circle-box .circle-right-box {
  right: 0;
}

.mid-bottom-circle-box .circle-left-box {
  left: 0;
}

.mid-bottom-circle-box .circle {
  width: 0.58rem;
  height: 0.58rem;
  border: 0.06rem solid transparent;
  border-radius: 50%;
  position: absolute;
  top: 0;
  transform: rotate(-135deg);
}

.mid-bottom-circle-box .circle-right {
  border-top: 0.06rem solid #25ff96;
  border-right: 0.06rem solid #25ff96;
  right: 0;
  -webkit-transform: rotate(45deg);
}
.mid-bottom-circle-box .circle-right2 {
  border-top: 0.06rem solid #ffae00;
  border-right: 0.06rem solid #ffae00;
  right: 0;
  -webkit-transform: rotate(45deg);
}

.mid-bottom-circle-box .circle-left {
  border-bottom: 0.06rem solid #25ff96;
  border-left: 0.06rem solid #25ff96;
  left: 0;
  -webkit-transform: rotate(45deg);
}
.mid-bottom-circle-box .circle-left2 {
  border-bottom: 0.06rem solid #ffae00;
  border-left: 0.06rem solid #ffae00;
  left: 0;
  -webkit-transform: rotate(45deg);
}
@-webkit-keyframes circle_right {
  0% {
    -webkit-transform: rotate(-135deg);
  }

  50%,
  100% {
    -webkit-transform: rotate(45deg);
  }
}

@-webkit-keyframes circle_left {
  0%,
  50% {
    -webkit-transform: rotate(-135deg);
  }

  100% {
    -webkit-transform: rotate(45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/moudles/ProductListMoudle.vue